// React
import React, { Component } from "react";

// Libraries
import Numeral from 'numeral';
import Scrollbar from 'react-smooth-scrollbar';

import { Dropdown } from '../../Components';

import { ClientRoutes } from '../../Routes';

import { CurrencyStore } from '../../Stores';

// Styles
import './pricer.css';

// The pricer component is stateless and receives all
// details from prices class
class MarketCap extends Component {
    
/**********************************************************
 *  Constructor
 **********************************************************/
    constructor(props) {

        super(props);

        this.state = {
            marketcaps : [],
            details : {
                "totalMarketCap": 0,
                "totalDayVolume": 0,
                "bitcoinDominance": 0
            },
            counts : [10, 25, 50, 100],
            count : 25,
            currencies : ["AUD", "BRL", "CAD", "CHF", "CLP", "CNY", "CZK", "DKK", "EUR", "GBP", "HKD", "HUF", "IDR", "ILS", "INR", "JPY", "KRW", "MXN", "MYR", "NOK", "NZD", "PHP", "PKR", "PLN", "RUB", "SEK", "SGD", "THB", "TRY", "TWD", "ZAR"],
            currency : 'USD',
            currencySymbol : CurrencyStore.getCurrencySymbol('USD')
        };

    }

/**********************************************************
 *  Component Lifecycle Functions
 **********************************************************/

    // After first render() is successfully executed, this function is called
    componentDidMount() {

        //console.log('MarketCap.componentDidMount()');

        this.fetchMarketCaps(this.state.currency, 100);

        ClientRoutes.getMarketCapDetails()
            .then( (details) => {

                this.setState((prevState,props) => {
                    return {
                        details : details
                    }
                });

            });

    }

/**********************************************************
 *  Helper Functions
 **********************************************************/

    // After currency or count updated, retrieve new market caps
    componentDidUpdate(prevProps, prevState) {

        if(prevState.currency !== this.state.currency)
            this.fetchMarketCaps(this.state.currency, 100);

    }

    // Fetch the market caps for given currency and count
    fetchMarketCaps(currency, count) {

        ClientRoutes.getMarketCaps(currency, count)
            .then( (marketcaps) => {

                this.setState((prevState,props) => {
                    return {
                        marketcaps : marketcaps
                    }
                });

            });

    }


    // Saves a new count selection
    selectCount(count) {

        if(count !== this.state.count) {

            this.setState((prevState,props) => {
                return {
                    count : count
                }
            });

        }

    }


    // Saves a new count selection
    selectCurrency(currency) {

        if(currency !== this.state.currency) {

            this.setState((prevState,props) => {
                return {
                    currency : currency,
                    currencySymbol : CurrencyStore.getCurrencySymbol(currency)
                }
            });

        }

    }

/**********************************************************
 *  Render
 **********************************************************/

    render() {

        const pricesHeight = window.innerHeight - 230;

        const marketcaps = this.state.marketcaps.slice(0, this.state.count);

        const fieldName = 'market_cap_' + this.state.currency.toLowerCase();

        return (

            <div>

                <div className="panel-heading" style={{paddingBottom:0}}>
                    <div className="flex-menu">
                        <div className="flex-menu-row price-menu" style={{marginBottom:0}}>

                            <div className="pill">
                                <div className="pill-label" style={{background:'#686dc7'}}>TOTAL</div>
                                <div className="pill-detail">{Numeral(this.state.details.totalMarketCap).format('$0.0a')}</div>
                            
                            </div>

                            <div className="pill">
                                <div className="pill-label" style={{background:'#e24a89'}}>VOLUME</div>
                                <div className="pill-detail">{Numeral(this.state.details.totalDayVolume).format('$0.0a')}</div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="panel-heading" style={{paddingBottom:0}}>
                
                    <div className="flex-menu">
                    
                        {/*-----------  Dropdown Menu -----------id="chart-menu-row"*/}
                        <div className="flex-menu-row price-menu">
                
                            {/*----------- Count -----------*/} 
                            <Dropdown icon='icon-rocket' value={'Top ' + this.state.count} >
                                {
                                    this.state.counts.map((count) => <li key={count} onClick={() => this.selectCount(count)}><a href={null}>{count}</a></li>)
                                }
                            </Dropdown>

                            {/*----------- Currencies -----------*/} 
                            <Dropdown icon='icon-coins' value={ this.state.currency } dropdownClasses={'dropdown-menu-right scroll'} >
                                {
                                    this.state.currencies.map((currency) => <li key={currency} onClick={() => this.selectCurrency(currency)}><a href={null}><div className='currency-symbol'>{CurrencyStore.getCurrencySymbol(currency)}</div>{currency}</a></li>)
                                }
                            </Dropdown>

                        </div>

                    </div>

                </div>

                <Scrollbar damping={0.1} thumbMinSize={20} continuousScrolling={true} renderByPixels={false} alwaysShowTracks={false}>

                <div className="panel-body prices-body" style={{ height: pricesHeight, paddingTop: 0, overflowY: 'visible' }}  >   
                    {
                        marketcaps.map( (currency) => {

                                const cap = Numeral(currency[fieldName]).format('0.00a');
                                const supply = Numeral((currency.market_cap_usd/this.state.details.totalMarketCap)*100).format('0.00');

                                return (
                                    <div className="flex-panel" key={currency.symbol} style={{paddingLeft:'28px'}}>

                                        <div className="ranking">
                                            <div>{currency.rank}</div>
                                        </div>
                                    
                                        <div className="child-row">
                        
                                            <div className="column-box left">
                        
                                                <div className="price-image">
                                                    <img src={'/assets/img/coins/' + currency.symbol + '.png'} className="img-circle img-xs" alt=""></img>
                                                </div>
                        
                                                <div className="row-box left">
                                                
                                                    <div>
                                                        {currency.name}
                                                    </div>
                        
                                                    <div className="italic lowlight">
                                                        {currency.symbol}
                                                    </div>
                            
                                                </div>
                        
                                            </div>
                        
                                            <div className="row-box right">
                    
                                                <div>
                                                    <span className="right-pad">{ this.state.currencySymbol }</span>
                                                    <span>{cap}</span>
                                                    <i className={currency.percent_change_24h > 0 ? 'icon-arrow-up8 green-text left-pad arrow hover-up' : 'icon-arrow-down8 red-text left-pad arrow hover-down'}></i>
                                                </div>
                    
                                                <div className='lowlight'>
                                                    {supply}% of Market
                                                </div>
                    
                                            </div>

                                        </div>
                        
                                    </div>
                                )
                        })
                    }

                </div>

                </Scrollbar>

            </div>

        );
    }

}

export default MarketCap;








// WEBPACK FOOTER //
// ./src/Views/Prices/MarketCap.js